export function ProvincialOverview() {
  const highlights = [
    {
      icon: 'ri-home-smile-line',
      title: 'No Principal Residence Requirement',
      description: 'Alberta is the most investor-friendly province in 2026. Both Calgary and Edmonton allow STR operations on investment properties, not just primary residences.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Two-Tiered Licensing (Calgary)',
      description: 'Calgary uses a tiered system: Tier 1 (~$172) for under 2 rooms, Tier 2 (~$510) for 3+ rooms or entire homes. Non-primary residents pay higher fees.'
    },
    {
      icon: 'ri-pause-circle-line',
      title: 'Vacancy Rate "Pause Rule"',
      description: 'Calgary stops issuing new licenses for non-primary homes if the rental vacancy rate drops below 2.5%, protecting long-term housing supply.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Guest Management Plans',
      description: 'Edmonton requires a comprehensive Guest Management Plan covering parking, noise control, and emergency procedures as part of the licensing process.'
    }
  ];

  const comparison = [
    {
      city: 'Calgary',
      license: 'Two-Tiered System',
      fee: '$172 (Tier 1) / $510 (Tier 2)',
      primaryRequired: 'No (higher fees for non-primary)',
      maxNights: '365 nights',
      enforcement: 'Proactive audits, $500+ fines'
    },
    {
      city: 'Edmonton',
      license: 'Business License',
      fee: '~$250 annually',
      primaryRequired: 'No (most investor-friendly)',
      maxNights: '365 nights',
      enforcement: 'Nuisance-focused, $500+ penalties'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Alberta: Canada's Most Flexible STR Market
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            In 2026, Alberta remains the most investor-friendly province for short-term rentals. Unlike BC and Ontario, Alberta does not require principal residence, allowing investment property STR operations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {highlights.map((highlight, index) => (
            <div 
              key={index}
              className="bg-[#F0F0F0] p-8 rounded-2xl hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#882629]/10 rounded-xl mb-6">
                <i className={`${highlight.icon} text-3xl text-[#882629]`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-4">
                {highlight.title}
              </h3>
              <p className="text-[#505A5A]/70 leading-relaxed">
                {highlight.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-[#F0F0F0] rounded-2xl p-8 lg:p-12">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-8 text-center">
            Calgary vs Edmonton: 2026 Comparison
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-[#882629]">
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">City</th>
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">License Type</th>
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">Annual Fee</th>
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">Primary Residence</th>
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">Max Nights</th>
                  <th className="text-left py-4 px-4 text-[#505A5A] font-semibold">Enforcement</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((row, index) => (
                  <tr key={index} className="border-b border-[#505A5A]/10">
                    <td className="py-4 px-4 font-semibold text-[#882629]">{row.city}</td>
                    <td className="py-4 px-4 text-[#505A5A]">{row.license}</td>
                    <td className="py-4 px-4 text-[#505A5A]">{row.fee}</td>
                    <td className="py-4 px-4 text-[#505A5A]">{row.primaryRequired}</td>
                    <td className="py-4 px-4 text-[#505A5A]">{row.maxNights}</td>
                    <td className="py-4 px-4 text-[#505A5A] text-sm">{row.enforcement}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 bg-[#882629]/5 border-l-4 border-[#882629] p-6 rounded-lg">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-2xl text-[#882629] flex-shrink-0 mt-1"></i>
            <div>
              <h4 className="font-semibold text-[#505A5A] mb-2">2026 Market Advantage</h4>
              <p className="text-[#505A5A]/70 leading-relaxed">
                Alberta's flexible regulations make it the top choice for STR investors in Canada. Calgary Stampede (July) generates the highest revenue window in the country, while Edmonton's Old Strathcona and West Edmonton Mall areas offer exceptional year-round ROI.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
